/*
*******************************************************************************************
This Enum is sorted alphabetically. Please consider this when you are adding new event type
*******************************************************************************************
*/

export enum BusinessModelEnum {
    B2C = 1,
    B2B = 2
  }

export enum BusinessTypeEnum {
    B2C = 'b2c',
    B2B = 'b2b'
  }
